module.exports = __webpack_public_path__ + "static/img/banner1.10324a36.jpeg";